<template src="./Password.html"></template>
<style scoped src="./Password.css"></style>

<script>

import store from "@/store/index.js";

const md5 = require("MD5");
const PASS_KEY = 'ABCDEFGHIJKLMNPQRSTVXZ0123456789';

export default {
  props: {
    closeDialog: {
      type: Function
    },
  },
  data() {
    return {
      generatedKey: String,
      keyTime: 0,
      countDown: 0 
    }
  },
  created() {
    this.refreshGeneratedKey();
    this.countDownProc();
  },
  computed: {
    user(){      
      return store.state.user.data
    }
  },
  methods: {
    refreshGeneratedKey() {
      this.keyTime = Math.trunc(Date.now() / 30000); 

      var aux = md5(this.keyTime.toString() + store.state.user.data.USULOGIN.toString()); 
      this.generatedKey = "";

      for (var i = 0; i < 8; i++){
        var numb = parseInt(aux.substring(i * 4, i * 4 + 4), 16);

        numb = numb % 32;

        this.generatedKey += PASS_KEY[numb];
      }
    },
    refreshCountDown() {
      this.countDown = ((Date.now() / 30000) - this.keyTime) * 100;
    },
    close(){
      this.$refs.form.reset()
      this.closeDialog();
    },
    countDownProc(){
      if (this.countDown >= 100)
        this.refreshGeneratedKey();      

      setTimeout(() => {
        this.refreshCountDown();
        this.countDownProc();
      }, 100);
    },
    copyKey() {
      navigator.clipboard.writeText(this.generatedKey);
    },
  }
};
</script>